// extracted by mini-css-extract-plugin
module.exports = {"input":"BitaCalendar_input__nwjyw","calendar":"BitaCalendar_calendar__1cuJf","text":"BitaCalendar_text__1Epf7","textMargin":"BitaCalendar_textMargin__5QIcS"};